import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';
import { motion } from 'framer-motion';

const Layout = () => {
  const navItems = [
    { path: '/', icon: 'Grid', label: 'Dashboard' },
    { path: '/closet', icon: 'Layers', label: 'Archive' },
    { path: '/studio', icon: 'Edit3', label: 'Studio' },
    { path: '/demo', icon: 'Zap', label: 'Demo' },
    { path: '/calendar', icon: 'Calendar', label: 'Calendar' },
    { path: '/settings', icon: 'Settings', label: 'Settings' },
  ];

  return (
    <div className="flex h-screen bg-pearl-50 bg-grid-pattern overflow-hidden font-sans">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r border-pearl-200 bg-white/50 backdrop-blur-md">
        <div className="p-6 flex items-center gap-3">
          <BrandMark className="w-9 h-9 shadow-sm" />
          <div className="flex flex-col">
            <span className="font-editorial font-bold text-lg leading-none tracking-tight">WardrobeWave</span>
            <span className="text-[9px] font-mono text-runway-500 uppercase tracking-widest mt-1">Fashion OS</span>
          </div>
        </div>
        
        <nav className="flex-1 px-4 py-6 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-xs font-mono uppercase tracking-widest transition-all duration-200 ${
                  isActive
                    ? 'bg-graphite-900 text-white shadow-lg'
                    : 'text-graphite-500 hover:bg-pearl-100 hover:text-graphite-900'
                }`
              }
            >
              <SafeIcon name={item.icon} className="w-3.5 h-3.5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-6 border-t border-pearl-200 bg-pearl-50/30">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-pearl-200 overflow-hidden ring-1 ring-pearl-200 ring-offset-2">
              <img 
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&q=80" 
                alt="User" 
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all" 
              />
            </div>
            <div className="overflow-hidden">
              <p className="text-[11px] font-bold uppercase truncate">Elias Vance</p>
              <p className="text-[9px] text-graphite-400 font-mono tracking-tighter">PREMIUM MEMBER</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 relative overflow-y-auto overflow-x-hidden pb-20 md:pb-0">
        <div className="max-w-6xl mx-auto p-4 md:p-10">
          <Outlet />
        </div>
      </main>

      {/* Mobile Bottom Nav */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 glass-panel border-t border-pearl-200 flex justify-around p-3 z-50">
        {navItems.slice(0, 4).map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 p-2 transition-colors ${
                isActive ? 'text-runway-500' : 'text-graphite-400'
              }`
            }
          >
            <SafeIcon name={item.icon} className="w-5 h-5" />
            <span className="text-[9px] font-mono uppercase font-bold">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Layout;